import axios from "axios";

export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== "production") console.warn(...args);
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Resolve the API base URL.
// - In development (localhost) we use REACT_APP_BACKEND_URL as-is (backend on a different port).
// - In production, when the page is served from a host different than REACT_APP_BACKEND_URL
//   (e.g. custom domain costanov.com, while build env points to xxx.emergent.host),
//   we call the API on the same origin to avoid cross-origin / CORS / cookie issues.
function resolveApiBase() {
  const fallback = `${BACKEND_URL}/api`;
  if (typeof window === "undefined") return fallback;
  const host = window.location.hostname;
  const isLocalhost = /^(localhost|127\.|0\.0\.0\.0)$/.test(host) || host.startsWith("127.");
  if (isLocalhost || !BACKEND_URL) return fallback;
  try {
    const cfg = new URL(BACKEND_URL);
    if (cfg.hostname !== host) {
      return `${window.location.origin}/api`;
    }
  } catch (err) {
    devWarn("Invalid BACKEND_URL, using fallback:", err);
  }
  return fallback;
}

export const API = resolveApiBase();

try {
  localStorage.removeItem("costanov_token");
} catch (err) {
  devWarn("localStorage unavailable:", err);
}

// Auth is cookie-only: the backend sets an HttpOnly + Secure cookie that JS cannot read.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "A aparut o eroare. Incearca din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatRON(value) {
  const n = Number(value || 0);
  return `${n.toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RON`;
}
